// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".route-and-print .el-link {\n  font-size: 12px;\n}\n.route-and-print .el-link.el-link--default {\n    color: #0052cc;\n}\n.route-and-print .el-link.el-link--default:hover {\n      color: #0052cc;\n}\n", ""]);
// Exports
module.exports = exports;
